export const authUrls = {
  login: '/auth/login',
  loginLanding: '/auth/login-landing',
  message: '/auth/msg-to-sign',
  user: '/user',
  refresh: '/auth/refresh',
  register: '/auth/register',
  isRegistered: (id: number) => `/pre-registration/${id}/is-registered-landing`,
  preregister: '/pre-registration/preregister-lending',
  preRegistrationIds: '/pre-registration/pre-registration-ids',
  changeNames: '/user/change-names'
};
